import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Select2Data } from 'ng-select2-component';
import { LogType, Status } from 'src/app/helpers/enum';
import { LocalCampaignOrderDataStatisticsModel, LocalCampaignOrderDataStatisticsTimechartModel } from 'src/app/models/renault-local-campaign-order-dto';
import { LocalCampaignOrderService } from 'src/app/services/local-campaign-order.service';
import Swal from 'sweetalert2';
import * as Highcharts from 'highcharts';
import funnel from 'highcharts/modules/funnel';
import { PuntoapuntoLocalCampaignOrderDataStatisticsModel, PuntoapuntoLocalCampaignOrderDataStatisticsTimechartModel } from 'src/app/models/renault-puntoapunto-local-campaign-order';
import { PuntoapuntoLocalCampaignOrderService } from 'src/app/services/puntoapunto-local-campaign-order.service';


funnel(Highcharts);


@Component({
  selector: 'puntoapunto-local-campaign-statistics-email',
  templateUrl: './puntoapunto-local-campaign-statistics-email.component.html',
  styleUrls: ['./puntoapunto-local-campaign-statistics-email.component.scss']
})
export class PuntoapuntoLocalCampaignStatisticsEmailComponent implements OnInit {

  @Input() idOrders: number[];
  modelStatistics: PuntoapuntoLocalCampaignOrderDataStatisticsModel;
  modeTimechart: PuntoapuntoLocalCampaignOrderDataStatisticsTimechartModel[] = [];
  enviados = 0;
  enviadosPorc = 0;
  abiertosPorc = 0;
  clicksPorc = 0;
  ventasPorc = 0;
  reactivity = 0;
  optout = 0;
  optoutPorc = 0;
  logTypeSelected = LogType.Open.toString();
  logTypeData: Select2Data = [];
  chartTime: Highcharts.Chart;
  chartConversion: Highcharts.Chart;
  public optionCampaignConversionChart: any = {
    chart: {
      type: 'funnel',
      backgroundColor: 'transparent'
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        borderColor: '#F1F1F2',
        borderWidth: 8,
        dataLabels: {
          format: '{point.name} {point.y:,.0f}'
        },
        center: ['50%', '50%'],
        width: '60%'
      }
    },
    legend: {
      enabled: false
    },
    series: [{
      name: 'Interacciones',
      data: []
    }]
  };
  public optionCampaignTimeChart: any = {
    chart: {
      type: 'spline'
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'datetime',
      DateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e. %b',
        week: '%e. %b',
        month: '%b \'%y',
        year: '%Y'
      },
      showLastLabel: true
    },
    tooltip: {
      headerFormat: '',
      pointFormat: '{series.name}: {point.y}'
    },
    yAxis: {
      title: {
        text: null
      }
    },
    legend: {
      enabled: false
    },
    series: [{
      name: 'Interacciones',
      data: []
    }]
  };


  constructor(private service: PuntoapuntoLocalCampaignOrderService) { }

  ngOnInit(): void {
    this.loadLogtype();
    // this.getStatistics();
    this.getStatisticsTimechart();
    this.getStatisticsConversionchart();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes["idOrders"] && changes["idOrders"].previousValue != undefined) {
      this.idOrders = changes["idOrders"].currentValue;
      // this.getStatistics();
      this.getStatisticsTimechart();
      this.getStatisticsConversionchart();
    }

  }


  loadLogtype() {
    this.logTypeData.push({ value: LogType.Open.toString(), label: 'Aperturas' });
    this.logTypeData.push({ value: LogType.Click.toString(), label: 'Clics' });
  }

  getStatisticsConversionchart() {
    this.service.getLocalCampaignOrderStatistics(this.idOrders).subscribe(resp => {
      Highcharts.setOptions({
        colors: ['#000000', '#5CBA63', '#FFBD69', '#4B9BF5', '#d8c4a0', '#CB4B32', '#60504a', '#66d8d0', '#244f35'],
        lang: {
          decimalPoint: ',',
          thousandsSep: '.'
        }
      });
      this.modelStatistics = resp;
      this.reactivity = this.modelStatistics.ClicksTotales * 100 / this.modelStatistics.Abiertos;
      this.enviados = this.modelStatistics.Status.find(x => x.IdStatus == Status.Enviado)?.Contador ?? 0;
      let enviadosDiv = this.enviados == 0 ? 1 : this.enviados;
      this.enviadosPorc = this.enviados * 100 / this.modelStatistics.TotalBbdd;
      this.abiertosPorc = this.modelStatistics.Abiertos * 100 / enviadosDiv;
      this.clicksPorc = this.modelStatistics.Clicks * 100 / this.modelStatistics.Abiertos;
      this.optout = this.modelStatistics.OptOut;
      this.optoutPorc = this.modelStatistics.OptOut * 100 / this.modelStatistics.Abiertos;

      this.optionCampaignConversionChart.series[0].data = [{
        y: this.modelStatistics.TotalBbdd,
        name: 'Contactos'
      }, {
        y: this.enviados,
        name: 'Éxito',
        percent: '(' + Math.round(this.enviadosPorc) + '%)'
      }, {
        y: this.modelStatistics.Abiertos,
        name: 'Abiertos',
        percent: '(' + Math.round(this.abiertosPorc) + '%)'
      }, {
        y: this.modelStatistics.Clicks,
        name: 'Clics',
        percent: '(' + Math.round(this.clicksPorc) + '%)'
      }];
      this.optionCampaignConversionChart.series[0].dataLabels = {
        format: '{point.name} {y:,0f} {point.percent}'
      };
      this.chartConversion = Highcharts.chart('chartCampaignConversion', this.optionCampaignConversionChart);
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  getStatisticsTimechart() {
    this.service.getLocalCampaignOrderStatisticsTimechart(this.idOrders).subscribe(resp => {
      Highcharts.setOptions({
        colors: ['#D8C4A0', '#978b7f', '#000000', '#4b9bf5', '#3232c4', '#d8c4a0', '#60504a', '#5cba63', '#66d8d0', '#ffbd69', '#cb4b32', '#244f35']
      });
      this.modeTimechart = resp;
      this.optionCampaignTimeChart.series[0].data = [];
      this.chartTime = Highcharts.chart('chartCampaignTime', this.optionCampaignTimeChart);
      this.selectLogType();
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  selectLogType() {
    if (this.chartTime) {
      const processedData = this.modeTimechart.filter(x => x.IdLogType == +this.logTypeSelected).map((data) => {
        return [new Date(data.CreationDate).getTime(), data.Contador]
      });

      let newSerie: any = {
        name: 'Interacciones',
        data: []
      };
      newSerie.data = processedData;
      this.chartTime.series[0].update(newSerie);
    }
  }

}
